export const NORMALIZE_CSS =
    '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css" />';

// FUN-3908: Placeholder height for standalone AI embeds while the sandbox is
// still loading. AI blocks typically hold the main page content, so reserving
// most of the viewport keeps blocks below the embed (e.g. a CTA button) from
// flashing near the top of the page and jumping down once the real height
// arrives. Only applied when the embed is not inside a layout column.
export const AI_EMBED_LOADING_MIN_HEIGHT = '900px'; // iPhone viewport height is 874px
